import { useEffect, useState } from "react";
import toast from "react-hot-toast";

const useGetQuestionInfo = (title) => {
  const [isLoading, setLoading] = useState(true);
  const [data, setData] = useState(null);

  useEffect(() => {
    const loadData = async () => {
      try {
        const res = await fetch("/intake_form_info.json");
        const data = await res.json();

        const info = data.find((item) => item.question_title === title);
        setData(info);
      } catch (error) {
        toast.error("There was an error while fetching the question");
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, [title]);

  return {
    data,
    isLoading,
  };
};

export default useGetQuestionInfo;
